import React from 'react';
import Loadable from '@caixue/react-loadable';
import { Loading } from 'components';

export default Loadable({
  loader: () => import('./PremierePublisherBrowserPage'),
  loading: () => <Loading />,
});
